import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";
import { ListAlt } from "@mui/icons-material";
import { useResponsive } from "../../../core/hooks/useResponsive";

const TradeLogGrid = ({ tradeLog, showBought = true }) => {
  const theme = useTheme();
  const { isCompact } = useResponsive();
  const primary = theme.palette.primary.main;
  const rows = Array.isArray(tradeLog) ? tradeLog : [];

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <ListAlt sx={{ color: primary, fontSize: 22 }} />
        <Typography variant="subtitle1" fontWeight={800}>
          Process log
        </Typography>
        <Typography variant="caption" color="text.secondary">
          ({rows.length} entries)
        </Typography>
      </Box>
      <TableContainer
        sx={{
          flex: 1,
          height: "100%",
          maxHeight: { xs: 300, lg: "unset" },
          overflow: "auto",
          borderRadius: 2,
          border: `1px solid ${alpha(primary, 0.12)}`,
          "& .MuiTableHead-root .MuiTableCell-root": {
            bgcolor: alpha(primary, 0.07),
            fontWeight: 800,
            fontSize: "0.7rem",
            textTransform: "uppercase",
            letterSpacing: 0.5,
            color: primary,
            borderBottom: `2px solid ${alpha(primary, 0.12)}`,
          },
          "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)": {
            bgcolor: alpha(theme.palette.action.hover, 0.04),
          },
          "& .MuiTableBody-root .MuiTableRow-root:hover": {
            bgcolor: alpha(primary, 0.05),
          },
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell width={isCompact ? 48 : 72}>{isCompact ? "#" : "Scan#"}</TableCell>
              <TableCell>Log message</TableCell>
              {showBought && (
                <TableCell width={isCompact ? 56 : 88}>{isCompact ? "Bt" : "Bought#"}</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={showBought ? 3 : 2}>
                  <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 3 }}>
                    No log lines yet.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, idx) => (
                <TableRow key={row.scan != null ? `scan-${row.scan}-${idx}` : idx}>
                  <TableCell sx={{ fontWeight: 600 }}>{row.scan}</TableCell>
                  <TableCell sx={{ fontSize: isCompact ? "0.72rem" : "0.8125rem", wordBreak: "break-word" }}>{row.logMessage}</TableCell>
                  {showBought && <TableCell>{row.bought}</TableCell>}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TradeLogGrid;
